module.exports = __webpack_public_path__ + "static/media/eye (1).fff14319.svg";